<template>
  <vca-card>
    <h2>{{ $t("network.crews.list.header") }}</h2>
    <vca-card class="shadowed vca-center">
      <CrewTable />
      <vca-popup
        v-if="current != null"
        :show="current != null"
        :title="$t('crews.popup.edit', { 0: current.name })"
        @close="current = null"
      >
        <CrewsEdit />
      </vca-popup>
    </vca-card>
  </vca-card>
</template>

<script>
import CrewTable from "@/components/network/crews/CrewTable";
import CrewsEdit from "@/components/network/crews/CrewEdit";
export default {
  name: "NetworkCrewList",
  components: { CrewTable, CrewsEdit },
  created() {
    this.current = null;
    this.$store.dispatch({ type: "crews/list" });
  },
  computed: {
    current: {
      get() {
        return this.$store.state.crews.current;
      },
      set(value) {
        this.$store.commit("crews/current", value);
      },
    },
  },
};
</script>
